import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { VerifiedStatusEnum } from '@itb-monorepo/enums';
import { TraderResponseModel } from '@itb-monorepo/models';
import { firstValueFrom } from 'rxjs';
import { TradersService } from '../../http-services/traders.service';

function getVerificationRoute(status: VerifiedStatusEnum): string | null {
  switch (status) {
    case VerifiedStatusEnum.PHONE_VERIFICATION:
      return 'phone';

    case VerifiedStatusEnum.IDENTITY_VERIFICATION:
      return 'personal-information';

    case VerifiedStatusEnum.BANK_CARD_VERIFICATION:
      return 'bank-card';

    default:
      return null;
  }
}

export const kycGuard: CanActivateFn = async (
  route
): Promise<boolean | UrlTree> => {
  const tradersService = inject(TradersService);
  const router = inject(Router);

  let trader: TraderResponseModel;

  try {
    trader = await firstValueFrom(tradersService.loadCurrentTrader());
  } catch {
    return router.createUrlTree(['/dashboard']);
  }

  const section = route.data?.['section'];
  const requestedPath = route.routeConfig?.path;
  const verificationPath = getVerificationRoute(trader.status);

  if (trader.status === VerifiedStatusEnum.VERIFIED) {
    if (section === 'settings') {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  }

  if (section === 'settings') {
    if (!verificationPath) {
      return router.createUrlTree(['/dashboard']);
    }

    return router.createUrlTree(['/verification', verificationPath]);
  }

  if (section === 'kyc') {
    if (!verificationPath) {
      return router.createUrlTree(['/dashboard']);
    }

    if (requestedPath === verificationPath) {
      return true;
    }

    return router.createUrlTree(['/verification', verificationPath]);
  }

  return true;
};
